import React, { useRef, useState } from 'react'
import { DescriptionSectionProps } from './types'
import './index.scss'

export const DescriptionSection: React.FC<DescriptionSectionProps> = ({ title, officialStoreImageUrl, smallDescription, description }) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const descriptionRef = useRef<HTMLParagraphElement>(null)

  const onClick = () => {
    const element = descriptionRef.current
    if (!element) return

    if (isCollapsed) {
      element.style.height = `${element.scrollHeight}px`
      setIsCollapsed(false)

      element.addEventListener(
        'transitionend',
        () => {
          element.style.height = 'auto'
        },
        { once: true }
      )
    } else {
      element.style.height = `${element.scrollHeight}px`

      requestAnimationFrame(() => {
        element.style.height = '0px'
      })

      setIsCollapsed(true)
    }
  }

  return (
    <div className="description-section">
      <div>
        <p className="brand-title">{title}</p>
        <p className="brand-description">{smallDescription}</p>
        <p ref={descriptionRef} className={`brand-description ${isCollapsed ? 'collapsed' : 'expanded'}`}>
          {description}
        </p>
      </div>
      <div className="description-footer-container">
        <button className="read-more-button" onClick={onClick}>
          {isCollapsed ? 'Leia mais' : 'Ler menos'}
        </button>
        <img src={officialStoreImageUrl} loading="lazy" alt="Offical Store Logo" />
      </div>
    </div>
  )
}
